export default "__VITE_ASSET__BSm6L9O3__"